module.exports = __webpack_public_path__ + "static/media/submit-av-play-sound.facd6e84.mp3";